<template>
  <div>
    {{ formattedTime }}
  </div>
</template>

<script>
export default {
  name: "Timer",
  props: {
    startSeconds: {
      type: Number,
      default: 0,
    },
    onFinishSeconds: {
      type: Number,
      default: Infinity,
    },
    logic: {
      type: String,
      default: "increase",
    },
    stopOnFinish: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      seconds: 0,
      intervalId: null,
    };
  },
  computed: {
    formattedTime: {
      get() {
        const hours = this.seconds / 3600;
        const minutes = (hours % 1) * 60;
        const seconds = (minutes % 1) * 60;

        const hoursText = Math.floor(hours);
        const minutesText = Math.floor(minutes);
        const secText = Math.round(seconds).toString().padStart(2, "0");

        if (!this.formatWithHelpers) {
          if (Math.floor(this.seconds) <= 59) {
            return `${secText}s`;
          }

          if (Math.floor(this.seconds) <= 3599) {
            return `${minutesText}:${secText}`;
          }

          return `${hoursText}:${minutesText
            .toString()
            .padStart(2, "0")}:${secText}`;
        }

        return `${hoursText.toString().padStart(2, "0")} hs ${minutesText
          .toString()
          .padStart(2, "0")} min ${secText} sec`;
      },
    },
  },
  mounted() {
    this.seconds = this.startSeconds;
  },
  methods: {
    start() {
      this.intervalId = setInterval(() => {
        if (this.logic === "increase") {
          this.seconds++;
          return;
        }

        this.seconds--;
      }, 1000);
    },
    stop() {
      clearInterval(this.intervalId);
      this.$emit("onStop");
    },
    reset() {
      this.seconds = this.startSeconds;
    },
  },
  watch: {
    seconds(val) {
      if (val === this.onFinishSeconds) {
        this.stop();
      }
    },
  },
};
</script>
